const LogoLight = require('../../assets/logo/logo-light.png');
const LogoContrast = require('../../assets/logo/logo-contrast.png');

export {LogoLight, LogoContrast};
